import React from 'react';
import star from '../features/attackSurface/assets/star.png';
import vSign from '../features/attackSurface/assets/v-sign.png';
import './RiskReportInfoWrapper.css';

const RiskReportInfoWrapper: React.FC = () => {

    return (
        <div className="upload-left">
            <div className="upload-badge">
                <img src={star} alt="" className='star-icon'/> Free Agentic Attack Surface Assessment
            </div>

            <h1 className="upload-title">
                Get Your Agent Risk Report
            </h1>

            <div className="upload-features">
                <h3 className="upload-features-title">YOUR REPORT INCLUDES</h3>

                <div className="upload-feature-item">
                <h4 className="upload-feature-title">
                    <img src={vSign} alt="" className="v-sign" />
                    Vulnerabilities Breakdown
                    </h4>
                <p className="upload-feature-description">Inventory of all tools and vulnerabilities (across your agent 
                    <br/>
                    workflow)</p>
                </div>

                <div className="upload-feature-item">
                <h4 className="upload-feature-title">
                    <img src={vSign} alt="" className="v-sign" />
                    Attack Surface Map</h4>
                <p className="upload-feature-description">Visual mapping of risk across your agent workflow</p>
                </div>

                <div className="upload-feature-item">
                <h4 className="upload-feature-title">
                    <img src={vSign} alt="" className="v-sign" />
                    Remediation Playbook
                </h4>
                <p className="upload-feature-description">Step-by-step fixes prioritized by impact</p>
                </div>

                <div className="upload-feature-item">
                <h4 className="upload-feature-title">
                    <img src={vSign} alt="" className="v-sign" />
                    Premium Frameworks
                </h4>
                <p className="upload-feature-description">Additional integrations available after purchase - contact us to unlock</p>
                </div>
            </div>
        </div>
    );
};

export default RiskReportInfoWrapper;